import { addBanner, addMasthead, addNative, addSkyscraper, addSkyscraperTop } from '../shared';
const selogerTypeMapping = {
    buy: 'achat/general',
    rent: 'location/general',
    life_annuity: 'achat/viager',
};
// Natives (6 with one spec per distribution type)
const createNative = (id, distributionType) => ({
    ...addNative({
        index: id,
        slotId: `/199043128/360-seloger/${selogerTypeMapping[distributionType]}/page-de-liste/native${id}`,
        id: `Native${id}`,
        distributionType,
    }),
    sizes: [['fluid']], // override default sizes for LI
    placeholderHeight: 240,
});
const addNatives = (numberOfNativeAds) => {
    const distributionTypes = ['buy', 'life_annuity', 'rent'];
    const natives = [];
    for (let i = 1; i <= numberOfNativeAds; i += 1) {
        distributionTypes.forEach((distributionType) => {
            natives.push(createNative(i, distributionType));
        });
    }
    return natives;
};
const createSkyscraper = (distributionType, id) => {
    const create = id === 'pave-bas' ? addSkyscraper : addSkyscraperTop;
    const type = selogerTypeMapping[distributionType];
    return create({
        distributionType,
        slotId: `/199043128/360-seloger/${type}/page-de-liste/${id}`,
        id,
    });
};
// Skyscrapers
const skyscrapers = [
    createSkyscraper('buy', 'pave-haut'),
    createSkyscraper('life_annuity', 'pave-haut'),
    createSkyscraper('rent', 'pave-haut'),
    createSkyscraper('buy', 'pave-bas'),
    createSkyscraper('life_annuity', 'pave-bas'),
    createSkyscraper('rent', 'pave-bas'),
];
const mastheadId = 'banner-haute-habillage';
const mastheadRentSlotId = '/199043128/360-seloger/location/general/page-de-liste/banner-haute-habillage';
const mastheadBuySlotId = '/199043128/360-seloger/achat/general/page-de-liste/banner-haute-habillage';
const mastheadLifeAnnuitySlotId = '/199043128/360-seloger/achat/viager/page-de-liste/banner-haute-habillage';
// Mastheads
const mastheads = [
    // Buy is the default masthead
    addMasthead({
        slotId: mastheadBuySlotId,
        id: mastheadId,
    }),
    addMasthead({
        distributionType: 'life_annuity',
        slotId: mastheadLifeAnnuitySlotId,
        id: mastheadId,
    }),
    addMasthead({
        distributionType: 'rent',
        slotId: mastheadRentSlotId,
        id: mastheadId,
    }),
];
// Banners - for mobile, in SOL, uses same id & slotId than the masthead
const banners = [
    {
        ...addBanner({
            slotId: mastheadBuySlotId,
            id: mastheadId,
        }),
        sizes: [[320, 50], [320, 100], [320, 150], ['fluid']],
        placeholderHeight: 240,
        placeholderHeightMobile: 150,
    },
    {
        ...addBanner({
            distributionType: 'life_annuity',
            slotId: mastheadRentSlotId,
            id: mastheadId,
        }),
        sizes: [[320, 50], [320, 100], [320, 150], ['fluid']],
        placeholderHeight: 240,
        placeholderHeightMobile: 150,
    },
    {
        ...addBanner({
            distributionType: 'rent',
            slotId: mastheadRentSlotId,
            id: mastheadId,
        }),
        sizes: [[320, 50], [320, 100], [320, 150], ['fluid']],
        placeholderHeight: 240,
        placeholderHeightMobile: 150,
    },
];
// Create a mobile-specific ad slots array that excludes skyscrapers
export const mobileAdSlots = [...mastheads, ...banners, ...addNatives(6)];
// Export the original adSlots array for desktop
export const adSlots = [...skyscrapers, ...mastheads, ...banners, ...addNatives(6)];
